import { render } from "./RelationPicker.vue?vue&type=template&id=bb669dd0"
import script from "./RelationPicker.vue?vue&type=script&lang=js"
export * from "./RelationPicker.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__